export const homeIndustries = [
  "Restaurants & Hospitality",
  "Medical & Healthcare",
  "Legal Services",
  "Fitness & Wellness",
  "Professional Services",
  "Entrepreneurs & Personal Brands",
  "Local Businesses",
  "Growing Companies",
];

export const industriesDetailed = [
  {
    title: "Restaurants & Hospitality",
    challenges: ["Inconsistent foot traffic", "Heavy dependence on reviews", "Seasonal demand shifts", "Intense local competition"],
    help: "Local visibility, reputation strategy, content that showcases the experience and promotional campaigns built around demand cycles.",
  },
  {
    title: "Medical & Healthcare",
    challenges: ["Trust-driven decisions", "Strict compliance requirements", "Rising patient acquisition cost", "Differentiation among providers"],
    help: "Credibility-focused branding, educational content strategy, local search visibility and a patient-friendly digital experience.",
  },
  {
    title: "Legal",
    challenges: ["Long decision cycles", "High competition for search terms", "Authority and trust requirements"],
    help: "Authority-driven brand positioning, content strategy, local and search visibility, and structured lead capture systems.",
  },
  {
    title: "Fitness & Wellness",
    challenges: ["Membership churn", "Seasonal interest spikes", "Crowded local market"],
    help: "Community-driven content, local promotion and lead funnels built around trials, classes and memberships.",
  },
  {
    title: "Professional Services",
    challenges: ["Explaining complex value simply", "Building trust at a distance", "Differentiating from competitors"],
    help: "Clear positioning, authority-building content and a conversion-focused web presence.",
  },
  {
    title: "Local Businesses",
    challenges: ["Limited marketing resources", "Competing with larger brands", "Inconsistent visibility"],
    help: "Google presence, local SEO, reputation systems and community-focused acquisition campaigns.",
  },
  {
    title: "Entrepreneurs & Personal Brands",
    challenges: ["Building a brand around a person", "Staying consistent across platforms", "Converting attention into clients"],
    help: "Personal brand strategy, content systems and a conversion-focused digital presence.",
  },
  {
    title: "Other Industries",
    challenges: ["Every growing business faces the same core problem — attention without a system to convert it."],
    help: "We build a custom strategy around your specific business, market and growth goals.",
  },
];
